/**
 * @param {string} textElementId - Id of the element whose text will be copied
 * @param {string} copyElementId - Id of the copy button element
 * @param {string} screenReaderAlertText - text that will be added into live region for screen reader users
 * @param {string} originalCopyText - original text of copy button element
 **/
import { shadowRoot } from "./_dom-context.js";

export function copyText(
	textElementId,
	copyElementId,
	screenReaderAlertText,
	originalCopyText = "Copy",
) {
	const textElement = shadowRoot.querySelector(textElementId);
	const copyElement = shadowRoot.querySelector(copyElementId);
	const screenReaderAlert = shadowRoot.getElementById("copy-alert");

	if (textElement && copyElement) {
		copyElement.addEventListener("click", (e) => {
			e.preventDefault();

			const text = textElement.textContent.trim();
			window.navigator.clipboard.writeText(text);
			screenReaderAlert.textContent = screenReaderAlertText;
			copyElement.dataset.disableClick = "true";
			copyElement.textContent = "Copied";

			setTimeout(() => {
				screenReaderAlert.textContent = "";
				delete copyElement.dataset.disableClick;
				copyElement.textContent = originalCopyText;
			}, 4000);

			copyElement.blur();
			return true;
		});
	}
}
